export interface FontFamily {
  heading: string;
  body: string;
  bold: string;
}

export interface FontSize {
  h1: number;
  h2: number;
  h3: number;
  h4: number;
  h5: number;
  h6: number;
  body: number;
  lead: number;
  small: number;
}

const fontSize: FontSize = {
  h1: 64,
  h2: 54,
  h3: 44,
  h4: 34,
  h5: 26,
  h6: 20,
  body: 16,
  lead: 24,
  small: 12
};

const fontFamily: FontFamily = {
  heading: "Merriweather",
  body: "Montserrat",
  bold: "Montserrat-Bold"
};

export default {
  fontSize,
  fontFamily
};
